export default __webpack_public_path__ + "static/media/Cord2.b1fd1da1.png";